import React from 'react';
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import useTextContents from '../../hooks/useTextContents'
import { AppState } from '../../store'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import PageScreen from '../../components/organisms/Page/PageScreen'
import { APP_COLOR, APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'

import {ReactComponent as ManualVerificationIcon} from '../../icons/svg/manual-verification-page-icon.svg'
import './ManualVerificationPage.scss'


const ManualVerificationClientPeselReservedPage = () => {
   const textContent = useTextContents()
   const manualVerificationPhoneNumberFromState = useSelector((state: AppState) => state.lenConfigState.globalConfig.manualVerificationPhoneNumber)
   const manualVerificationPhoneNumber = isEmpty(manualVerificationPhoneNumberFromState)? "58 73 900 99" : manualVerificationPhoneNumberFromState

   
   return (
      <PageScreen
         title={{title: textContent('manualVerificationPage.clientPeselReserved.header'), line: true}}
         icon={{ icon: ManualVerificationIcon, decorative: true, color: 'var(--color-primary-600)' }}
      >
         <div className='manual-verification-description'>
            <Paragraph html={textContent('manualVerificationPage.clientPeselReserved.mainContent', { manualVerificationPhoneNumber })} />
         </div>
         <Paragraph size={APP_FONT_SIZE.SMALL} color={APP_COLOR.GRAY}  align={"center"}>
            {textContent('manualVerificationPage.tip')}
         </Paragraph>
      </PageScreen>
   )
}

export default ManualVerificationClientPeselReservedPage